import { useState, useEffect } from 'react';

function useTime(delay: number | null) {
   const [elapsed, setElapsed] = useState(0)

   useEffect(() => {
      function tick() {
         setElapsed((prev) => prev + 1)
      }
      if (delay !== null) {
         let id = setInterval(tick, delay);
         return () => clearInterval(id);
      }
   }, [delay]);

   return elapsed
}

export default useTime;